export default __webpack_public_path__ + "static/media/opsmatic.44396018.svg";